export const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const CONSENT_KEY = 'imperia_ai_cookie_consent';
export const CONSENT_EVENT = 'imperia-ai:consent-changed';
export const COOKIE_SETTINGS_EVENT = 'imperia-ai:cookie-settings';
let configured = false;

export function analyticsHostAllowed() {
  const hosts = (process.env.REACT_APP_ANALYTICS_HOSTS || '').split(',').map(host => host.trim().toLowerCase()).filter(Boolean);
  return window.location.protocol === 'https:' && hosts.includes(window.location.hostname.toLowerCase());
}

export function publicAnalyticsPath(pathname) {
  return !/^\/(admin|platform|portal|auth|dashboard|team|onboarding|verify-email|scan)(\/|$)/.test(pathname);
}

export function getConsent() {
  try {
    const saved = JSON.parse(localStorage.getItem(CONSENT_KEY));
    if (saved?.version === 1 && typeof saved.analytics === 'boolean' && typeof saved.ads === 'boolean') return saved;
  } catch { /* No storage access means no tracking consent. */ }
  return null;
}

export function applyConsent(consent) {
  if (!analyticsHostAllowed() || !GA4_ID || !ADS_ID || !window.gtag) return;
  const analytics = consent?.analytics === true;
  const ads = consent?.ads === true;
  window.gtag('consent', 'update', {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: ads ? 'granted' : 'denied',
    ad_user_data: ads ? 'granted' : 'denied',
    ad_personalization: ads ? 'granted' : 'denied',
  });
  if (configured || !publicAnalyticsPath(window.location.pathname)) return;
  configured = true;
  // Advanced Consent Mode: load immediately; optional storage remains denied by default.
  // Manual page views omit query/hash. Enhanced Measurement must be disabled in GA4.
  const page = { page_location: window.location.origin + window.location.pathname, page_referrer: '', send_page_view: false };
  window.gtag('config', ADS_ID, page);
  window.gtag('config', GA4_ID, { ...page, allow_google_signals: false, allow_ad_personalization_signals: ads });
  const script = document.createElement('script');
  script.id = 'imperia-google-tag';
  script.dataset.testid = 'google-tag-loader';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);
}

export function saveConsent(analytics, ads) {
  const consent = { version: 1, analytics, ads, updatedAt: new Date().toISOString() };
  try { localStorage.setItem(CONSENT_KEY, JSON.stringify(consent)); } catch { /* Session-only choice. */ }
  applyConsent(consent);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: consent }));
}

export function trackPageView(pathname, referrer) {
  if (!analyticsHostAllowed() || !GA4_ID || !window.gtag) return;
  window.gtag('event', 'page_view', {
    send_to: GA4_ID,
    page_location: window.location.origin + pathname,
    page_path: pathname,
    page_title: document.title,
    page_referrer: referrer ? window.location.origin + referrer : '',
  });
}